export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 9_13.b4d05de3.jpg";